import * as React from "react";
import { UserBannerProps } from "../../../type";

export const UserBanner: React.FC<UserBannerProps> = ({ userId,userName,userProfile, membershipInfo, verificationStatus }) => {
  return (
    <div className="flex gap-5 justify-between pr- mt-8 max-w-full bg-orange-100 rounded-xl shadow-sm w-[970px] max-md:pr-5">
<div className="flex flex-col items-center justify-center text-center py-4 px-4 bg-amber-400 rounded-xl w-1/3 h-full">
  {/* Avatar */}
  <div className="flex flex-col items-center justify-center">
  <img
    loading="lazy"
    src={userProfile}
    alt="User avatar"
    className="w-20 h-20 rounded-full object-cover mx-auto"
  />
</div>


  {/* Username */}
  <div className="mt-3 text-lg font-bold text-zinc-800">{userName}</div>

  {/* User ID */}
  <div className="text-sm font-medium text-zinc-800">{userId}</div>

  {/* Bottom Image */}
  <img
    loading="lazy"
    src="https://cdn.builder.io/api/v1/image/assets/TEMP/5895e90ed1647bcaac27545300ff2a55635b11a8e9cf04d24663a69b0f87ea04?placeholderIfAbsent=true&apiKey=61022fe3774e4aa287a6264de6b79c87"
    alt="Decoration"
    className="object-contain mt-3 w-[68px] mx-auto"
  />
</div>



      <div className="flex flex-col my-auto text-xs max-md:max-w-full">
        <div className="flex flex-wrap gap-5 justify-between items-start px-3.5 pt-2 pb-3.5 bg-cyan-700 rounded-md max-md:max-w-full mr-10">
          <div className="flex flex-col mt-1.5 text-white">
            <div className="self-start font-bold text-xl">{membershipInfo.title}</div>
            <div className="mt-3 font-medium">{membershipInfo.description}</div>
          </div>
          {/* <button className="px-3.5 py-1.5 font-medium text-center text-cyan-700 whitespace-nowrap bg-white rounded-[36px]">
            {membershipInfo.ctaText}
          </button> */}
        </div>
        <div className="mt-3.5 font-medium text-gray-700 max-md:max-w-full">
          <span className="text-sm font-bold leading-5">
            Verification in progress:
          </span>{" "}
          <span className="text-sm leading-5">{verificationStatus}</span>
        </div>
      </div>
     
    </div>
  ); 
};